import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';

import { STORE_BACKEND_URL } from 'src/app/app.config';
import { ProductStatisticTotals } from '../../shared/models/product-statistic-totals.model';
import { GetProductStatisticTotalsRequest } from './get-product-statistic-totals.request';

@Injectable({
    providedIn: 'root'
})
export class LoadProductGlobalTotalsUseCase extends UseCase<GetProductStatisticTotalsRequest, Observable<ProductStatisticTotals>> {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: GetProductStatisticTotalsRequest | void): Observable<ProductStatisticTotals> | void {
        return this._apiRequestService.sendRequest<GetProductStatisticTotalsRequest, ProductStatisticTotals>(
            this._storeBaseUrl,
            request as GetProductStatisticTotalsRequest,
            true,
            '/admin/getTotalProductStatistics'
        );
    }
}
